import { Component } from '@angular/core';
import { LoCard, LoSkeleton } from 'lo-design-system';

/**
 * Loading placeholder that mirrors {@link PlanCardComponent}'s frame and
 * spacing - name, subtitle, price, dial, CTA and feature rows.
 * Shared by the pricing and settings plan grids so the skeleton matches the
 * real card exactly.
 */
@Component({
	standalone: true,
	selector: 'app-plan-card-skeleton',
	template: `
		<lo-card>
			<lo-skeleton variant="text" width="55%"></lo-skeleton>
			<lo-skeleton
				variant="block"
				height="calc(var(--lo-space-card) * 1.5)"
			></lo-skeleton>
			<lo-skeleton
				variant="text"
				width="45%"
				height="calc(var(--lo-space-card) * 1.5)"
			></lo-skeleton>
			<lo-skeleton
				variant="block"
				height="calc(var(--lo-space-card) * 1.5)"
			></lo-skeleton>
			<lo-skeleton
				variant="block"
				height="calc(var(--lo-space-card) * 1.5)"
			></lo-skeleton>
			<div class="sk-rows">
				@for (row of rows; track row) {
				<lo-skeleton variant="text"></lo-skeleton>
				}
			</div>
		</lo-card>
	`,
	styles: [
		`
			:host {
				display: flex;
				flex-direction: column;

				lo-card {
					flex: 1 1 auto;
				}

				.sk-rows {
					display: flex;
					flex-direction: column;
					gap: var(--lo-space-gap-md);
				}
			}
		`
	],
	imports: [LoCard, LoSkeleton]
})
export class PlanCardSkeletonComponent {
	readonly rows = [0, 1, 2, 3, 4, 5, 6, 7];
}
